import DiagnosticsModule, {
  MetricNames,
  MetricTags,
  type SubscriptionRetryOutcome,
} from '@modules/DiagnosticsModule';

/**
 * Counts a GraphQL user-subscription retry. Lives outside
 * UserSubscriptionManager because that file can't import DiagnosticsModule
 * without closing an import cycle through SentryErrorIntegration → AuthModule.
 */
export function recordSubscriptionRetry(
  outcome: SubscriptionRetryOutcome,
  attempt: string,
): void {
  DiagnosticsModule.incrementCounter(MetricNames.GQL_SUBSCRIPTION_RETRY_TOTAL, {
    [MetricTags.OUTCOME]: outcome,
    [MetricTags.ATTEMPT]: attempt,
  });
}
